import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

// ============================================================
// ENDPOINTS
// ============================================================

const URL_PRESENTES =
  "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPresentesPorSedeYPromocion";

const URL_CREAR_AVISOS =
  "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/creaAvisosInternosMasivos";

// SI TU ENDPOINT TIENE OTRO NOMBRE, CAMBIAR ESTA URL
const URL_PROMOCIONES =
  "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelvePromociones";

// ============================================================
// COMPONENTE
// ============================================================

const CreaAvisosInternosMasivos = ({ sede }) => {

  // ============================================================
  // STATES
  // ============================================================

  const [promociones, setPromociones] = useState([]);
  const [promocionId, setPromocionId] = useState("");

  const [cadetes, setCadetes] = useState([]);
  const [cadetesSeleccionados, setCadetesSeleccionados] =
    useState([]);

  const [busqueda, setBusqueda] = useState("");
  const [companiaFiltro, setCompaniaFiltro] = useState("");

  const [fechaNueva, setFechaNueva] = useState("");
  const [fechasSeleccionadas, setFechasSeleccionadas] =
    useState([]);

  const [buscando, setBuscando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [cargandoPromociones, setCargandoPromociones] =
    useState(false);

  // ============================================================
  // TOKEN
  // ============================================================

  const obtieneToken = () => {
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;

    return btoa(`${username}:${password}`);
  };

  // ============================================================
  // HELPERS
  // ============================================================

  const devuelveDni = (cadete) =>
    cadete?.cadeteDni || "";

  const devuelveApellido = (cadete) =>
    cadete?.cadeteApellido?.trim() || "";

  const devuelveNombre = (cadete) =>
    cadete?.cadeteNombre?.trim() || "";

  const devuelveSede = (cadete) =>
    cadete?.cadeteSede || "";

  const devuelveSeccion = (cadete) =>
    cadete?.Seccion?.nombre || "";

  const devuelveCompania = (cadete) =>
    cadete?.Seccion?.Compania?.nombre || "";

  const devuelvePromocion = (cadete) =>
    cadete?.Promocions?.[0]?.nombre || "";

  const devuelvePromocionId = (cadete) =>
    cadete?.Promocions?.[0]?.id || null;

  const devuelveFechaPresente = (cadete) =>
    cadete?.Asistencias?.[0]?.fecha || null;

  // ============================================================
  // FECHA / HORA PRESENTE
  // ============================================================

  const formatearHoraPresente = (fecha) => {
    if (!fecha) return "";

    try {
      return new Date(fecha).toLocaleTimeString(
        "es-AR",
        {
          hour: "2-digit",
          minute: "2-digit",
        }
      );
    } catch {
      return "";
    }
  };

  // ============================================================
  // PROMOCIONES
  // ============================================================

const cargarPromociones = async () => {
  try {
    setCargandoPromociones(true);

    const token = obtieneToken();

    const response = await axios.post(
      URL_PROMOCIONES,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );

    console.log("📚 RESPUESTA PROMOCIONES:", response.data);

    // EL ENDPOINT DEVUELVE DIRECTAMENTE UN ARRAY
    const datos = Array.isArray(response.data)
      ? response.data
      : [];

    // OPCIONAL:
    // Excluimos promociones que no querés usar
    const promocionesValidas = datos.filter(
      (promocion) =>
        promocion.nombre !== "Prueba"
    );

    setPromociones(promocionesValidas);

  } catch (error) {
    console.error(
      "❌ Error cargando promociones:",
      error
    );

    console.error(
      "Respuesta backend:",
      error.response?.data
    );

    setPromociones([]);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudieron cargar las promociones.",
    });

  } finally {
    setCargandoPromociones(false);
  }
};

  // ============================================================
  // INICIO
  // ============================================================

  useEffect(() => {
    cargarPromociones();
  }, []);

  // ============================================================
  // CAMBIO DE SEDE
  // ============================================================

  useEffect(() => {
    setPromocionId("");
    setCadetes([]);
    setCadetesSeleccionados([]);
    setBusqueda("");
    setCompaniaFiltro("");
  }, [sede]);

  // ============================================================
  // CONSULTAR PRESENTES
  // ============================================================

  const cargarCadetesPresentes = async (idPromocion) => {
    try {

      if (!sede || !idPromocion) {
        setCadetes([]);
        setCadetesSeleccionados([]);
        return;
      }

      setBuscando(true);

      setCadetes([]);
      setCadetesSeleccionados([]);
      setBusqueda("");
      setCompaniaFiltro("");

      const token = obtieneToken();

      const body = {
        sede,
        promocionId: Number(idPromocion),
      };

      console.log("======================================");
      console.log("📤 BUSCANDO PRESENTES");
      console.log("BODY:", body);
      console.log("======================================");

      const response = await axios.post(
        URL_PRESENTES,
        body,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("======================================");
      console.log("📥 RESPUESTA PRESENTES");
      console.log(response.data);
      console.log("======================================");

      const datos = Array.isArray(
        response.data?.datos
      )
        ? response.data.datos
        : [];

      console.log(
        "✅ Cantidad presentes:",
        datos.length
      );

      setCadetes(datos);

    } catch (error) {

      console.error(
        "❌ Error obteniendo presentes:",
        error
      );

      console.error(
        "Respuesta backend:",
        error.response?.data
      );

      setCadetes([]);
      setCadetesSeleccionados([]);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "No se pudieron obtener los cadetes presentes.",
      });

    } finally {

      setBuscando(false);

    }
  };

  // ============================================================
  // CAMBIO PROMOCIÓN
  // ============================================================

  const cambiaPromocion = (e) => {

    const valor = e.target.value;

    setPromocionId(valor);

    if (!valor) {
      setCadetes([]);
      setCadetesSeleccionados([]);
      return;
    }

    cargarCadetesPresentes(valor);
  };

  // ============================================================
  // COMPAÑÍAS DISPONIBLES
  // ============================================================

  const companias = useMemo(() => {

    const listado = cadetes
      .map((cadete) =>
        devuelveCompania(cadete)
      )
      .filter(Boolean);

    return [
      ...new Set(listado),
    ].sort();

  }, [cadetes]);

  // ============================================================
  // FILTRAR CADETES
  // ============================================================

  const cadetesFiltrados = useMemo(() => {

    let resultado = [...cadetes];

    // ==========================================================
    // COMPAÑÍA
    // ==========================================================

    if (companiaFiltro) {

      resultado = resultado.filter(
        (cadete) =>
          devuelveCompania(cadete) ===
          companiaFiltro
      );

    }

    // ==========================================================
    // BUSCADOR
    // ==========================================================

    if (busqueda.trim()) {

      const texto =
        busqueda.trim().toLowerCase();

      resultado = resultado.filter(
        (cadete) => {

          const nombreCompleto = `
            ${devuelveApellido(cadete)}
            ${devuelveNombre(cadete)}
          `.toLowerCase();

          const dni = String(
            devuelveDni(cadete)
          ).toLowerCase();

          const compania = devuelveCompania(
            cadete
          ).toLowerCase();

          const seccion = devuelveSeccion(
            cadete
          ).toLowerCase();

          return (
            nombreCompleto.includes(texto) ||
            dni.includes(texto) ||
            compania.includes(texto) ||
            seccion.includes(texto)
          );
        }
      );

    }

    return resultado;

  }, [
    cadetes,
    busqueda,
    companiaFiltro,
  ]);

  // ============================================================
  // SELECCIONADO
  // ============================================================

  const estaSeleccionado = (cadete) => {

    const dni = String(
      devuelveDni(cadete)
    );

    return cadetesSeleccionados.some(
      (item) =>
        String(devuelveDni(item)) === dni
    );
  };

  // ============================================================
  // TOGGLE
  // ============================================================

  const toggleCadete = (cadete) => {

    const dni = String(
      devuelveDni(cadete)
    );

    setCadetesSeleccionados(
      (anteriores) => {

        const existe = anteriores.some(
          (item) =>
            String(devuelveDni(item)) ===
            dni
        );

        if (existe) {

          return anteriores.filter(
            (item) =>
              String(devuelveDni(item)) !==
              dni
          );

        }

        return [
          ...anteriores,
          cadete,
        ];

      }
    );
  };

  // ============================================================
  // SELECCIONAR TODOS LOS VISIBLES
  // ============================================================

  const seleccionarTodosVisibles = () => {

    setCadetesSeleccionados(
      (anteriores) => {

        const mapa = new Map();

        anteriores.forEach(
          (cadete) => {
            mapa.set(
              String(devuelveDni(cadete)),
              cadete
            );
          }
        );

        cadetesFiltrados.forEach(
          (cadete) => {
            mapa.set(
              String(devuelveDni(cadete)),
              cadete
            );
          }
        );

        return Array.from(
          mapa.values()
        );
      }
    );
  };

  // ============================================================
  // QUITAR TODOS LOS VISIBLES
  // ============================================================

  const quitarTodosVisibles = () => {

    const visibles = new Set(
      cadetesFiltrados.map(
        (cadete) =>
          String(devuelveDni(cadete))
      )
    );

    setCadetesSeleccionados(
      (anteriores) =>
        anteriores.filter(
          (cadete) =>
            !visibles.has(
              String(devuelveDni(cadete))
            )
        )
    );
  };

  // ============================================================
  // LIMPIAR TODOS
  // ============================================================

  const limpiarSeleccion = () => {
    setCadetesSeleccionados([]);
  };

  // ============================================================
  // TODOS LOS VISIBLES ESTÁN SELECCIONADOS
  // ============================================================

  const todosVisiblesSeleccionados =
    cadetesFiltrados.length > 0 &&
    cadetesFiltrados.every(
      (cadete) =>
        estaSeleccionado(cadete)
    );

  // ============================================================
  // AGREGAR FECHA
  // ============================================================

  const agregarFecha = () => {

    if (!fechaNueva) {

      Swal.fire({
        icon: "warning",
        title: "Seleccione una fecha",
      });

      return;
    }

    if (
      fechasSeleccionadas.includes(
        fechaNueva
      )
    ) {

      Swal.fire({
        icon: "info",
        title: "Fecha repetida",
        text:
          "La fecha seleccionada ya fue agregada.",
      });

      return;
    }

    setFechasSeleccionadas(
      (anteriores) =>
        [
          ...anteriores,
          fechaNueva,
        ].sort()
    );

    setFechaNueva("");
  };

  // ============================================================
  // QUITAR FECHA
  // ============================================================

  const quitarFecha = (fecha) => {

    setFechasSeleccionadas(
      (anteriores) =>
        anteriores.filter(
          (item) => item !== fecha
        )
    );
  };

  // ============================================================
  // DNIS
  // ============================================================

  const dnisSeleccionados =
    useMemo(() => {

      return [
        ...new Set(
          cadetesSeleccionados
            .map((cadete) =>
              String(
                devuelveDni(cadete)
              ).trim()
            )
            .filter(Boolean)
        ),
      ];

    }, [cadetesSeleccionados]);

  // ============================================================
  // TOTAL
  // ============================================================

  const totalAvisos =
    dnisSeleccionados.length *
    fechasSeleccionadas.length;

  // ============================================================
  // PROMOCIÓN SELECCIONADA
  // ============================================================

  const promocionSeleccionada =
    promociones.find(
      (promocion) =>
        String(promocion.id) ===
        String(promocionId)
    );

  // ============================================================
  // CREAR AVISOS
  // ============================================================

  const enviarAvisos = async () => {

    try {

      // ========================================================
      // VALIDACIONES
      // ========================================================

      if (!sede) {

        Swal.fire({
          icon: "warning",
          title: "Falta la sede",
        });

        return;
      }

      if (!promocionId) {

        Swal.fire({
          icon: "warning",
          title: "Seleccione una promoción",
        });

        return;
      }

      if (
        dnisSeleccionados.length === 0
      ) {

        Swal.fire({
          icon: "warning",
          title:
            "No seleccionó ningún cadete",
        });

        return;
      }

      if (
        fechasSeleccionadas.length === 0
      ) {

        Swal.fire({
          icon: "warning",
          title:
            "Debe seleccionar al menos una fecha",
        });

        return;
      }

      // ========================================================
      // CONFIRMAR
      // ========================================================

      const confirmacion =
        await Swal.fire({

          icon: "question",

          title:
            "Confirmar internos",

          html: `
            <div style="text-align:left">

              <p>
                <strong>Sede:</strong>
                ${sede}
              </p>

              <p>
                <strong>Promoción:</strong>
                ${
                  promocionSeleccionada?.nombre ||
                  devuelvePromocion(
                    cadetesSeleccionados[0]
                  ) ||
                  promocionId
                }
              </p>

              <p>
                <strong>Cadetes:</strong>
                ${dnisSeleccionados.length}
              </p>

              <p>
                <strong>Fechas:</strong>
                ${fechasSeleccionadas.length}
              </p>

              <hr />

              <p style="
                font-size:18px;
                text-align:center;
              ">
                Se crearán
                <strong>
                  ${totalAvisos}
                </strong>
                aviso${
                  totalAvisos !== 1
                    ? "s"
                    : ""
                } de interno
              </p>

            </div>
          `,

          showCancelButton: true,

          confirmButtonText:
            "Sí, crear internos",

          cancelButtonText:
            "Cancelar",
        });

      if (
        !confirmacion.isConfirmed
      ) {
        return;
      }

      // ========================================================
      // BODY
      // ========================================================

      const body = {

        cadetesDni:
          dnisSeleccionados,

        fechas:
          fechasSeleccionadas,

        sede,
      };

      console.log("======================================");
      console.log("📤 CREANDO INTERNOS");
      console.log(body);
      console.log("======================================");

      setEnviando(true);

      const token =
        obtieneToken();

      const response =
        await axios.post(
          URL_CREAR_AVISOS,
          body,
          {
            headers: {
              Authorization:
                `Basic ${token}`,
              "Content-Type":
                "application/json",
            },
          }
        );

      console.log(
        "📥 RESPUESTA CREACIÓN:",
        response.data
      );

      const resumen =
        response.data?.resumen || {};

      // ========================================================
      // RESULTADO
      // ========================================================

      await Swal.fire({

        icon:
          resumen.errores > 0
            ? "warning"
            : "success",

        title:
          "Proceso finalizado",

        html: `
          <div style="text-align:left">

            <p>
              <strong>Cadetes:</strong>
              ${
                resumen.cadetes ??
                dnisSeleccionados.length
              }
            </p>

            <p>
              <strong>Fechas:</strong>
              ${
                resumen.fechas ??
                fechasSeleccionadas.length
              }
            </p>

            <p>
              <strong>Creados:</strong>
              ${resumen.creados ?? 0}
            </p>

            <p>
              <strong>Reactivados:</strong>
              ${resumen.reactivados ?? 0}
            </p>

            <p>
              <strong>Errores:</strong>
              ${resumen.errores ?? 0}
            </p>

          </div>
        `,
      });

      // ========================================================
      // LIMPIAR
      // ========================================================

      setCadetesSeleccionados([]);
      setFechasSeleccionadas([]);
      setFechaNueva("");

      // ACTUALIZAMOS PRESENTES
      await cargarCadetesPresentes(
        promocionId
      );

    } catch (error) {

      console.error(
        "❌ ERROR CREANDO INTERNOS:",
        error
      );

      console.error(
        "Respuesta:",
        error.response?.data
      );

      Swal.fire({
        icon: "error",

        title:
          "No se pudieron crear los internos",

        text:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Ocurrió un error.",
      });

    } finally {

      setEnviando(false);

    }
  };

  // ============================================================
  // RETURN
  // ============================================================

  return (
    <div style={styles.container}>

      {/* ====================================================== */}
      {/* CABECERA */}
      {/* ====================================================== */}

      <div style={styles.header}>

        <div>

          <h2 style={styles.title}>
            Crear avisos de interno
          </h2>

          <p style={styles.subtitle}>
            Solo se muestran cadetes
            presentes en el día de hoy.
          </p>

        </div>

        <div style={styles.sedeBadge}>
          📍 {sede || "Sin sede"}
        </div>

      </div>

      {/* ====================================================== */}
      {/* PROMOCIÓN */}
      {/* ====================================================== */}

      <div style={styles.section}>

        <label style={styles.label}>
          Promoción
        </label>

        <select
          value={promocionId}
          onChange={cambiaPromocion}
          disabled={
            cargandoPromociones ||
            !sede
          }
          style={styles.select}
        >

          <option value="">
            {cargandoPromociones
              ? "Cargando..."
              : "Seleccione una promoción"}
          </option>

          {promociones.map(
            (promocion) => (

              <option
                key={promocion.id}
                value={promocion.id}
              >
                {promocion.nombre}
              </option>

            )
          )}

        </select>

      </div>

      {/* ====================================================== */}
      {/* CARGANDO */}
      {/* ====================================================== */}

      {buscando && (

        <div style={styles.loading}>
          Consultando cadetes presentes...
        </div>

      )}

      {/* ====================================================== */}
      {/* LISTADO */}
      {/* ====================================================== */}

      {!buscando &&
        promocionId &&
        cadetes.length > 0 && (

          <>

            {/* ================================================== */}
            {/* ESTADÍSTICAS */}
            {/* ================================================== */}

            <div style={styles.stats}>

              <div style={styles.stat}>

                <strong style={styles.statNumber}>
                  {cadetes.length}
                </strong>

                <span style={styles.statLabel}>
                  presentes
                </span>

              </div>

              <div style={styles.stat}>

                <strong style={styles.statNumber}>
                  {
                    cadetesSeleccionados.length
                  }
                </strong>

                <span style={styles.statLabel}>
                  seleccionados
                </span>

              </div>

              <div style={styles.stat}>

                <strong style={styles.statNumber}>
                  {companias.length}
                </strong>

                <span style={styles.statLabel}>
                  compañías
                </span>

              </div>

            </div>

            {/* ================================================== */}
            {/* FILTROS */}
            {/* ================================================== */}

            <div style={styles.filters}>

              <input
                type="text"
                value={busqueda}
                onChange={(e) =>
                  setBusqueda(
                    e.target.value
                  )
                }
                placeholder="Buscar apellido, nombre o DNI..."
                style={styles.search}
              />

              <select
                value={companiaFiltro}
                onChange={(e) =>
                  setCompaniaFiltro(
                    e.target.value
                  )
                }
                style={styles.companiaSelect}
              >

                <option value="">
                  Todas las compañías
                </option>

                {companias.map(
                  (compania) => (

                    <option
                      key={compania}
                      value={compania}
                    >
                      {compania}
                    </option>

                  )
                )}

              </select>

            </div>

            {/* ================================================== */}
            {/* CONTROLES */}
            {/* ================================================== */}

            <div style={styles.listHeader}>

              <div>

                <strong>
                  {
                    cadetesFiltrados.length
                  }{" "}
                  cadete
                  {
                    cadetesFiltrados.length !==
                    1
                      ? "s"
                      : ""
                  }
                </strong>

                {(busqueda ||
                  companiaFiltro) && (

                  <span style={styles.filteredText}>
                    {" "}
                    de {cadetes.length}
                  </span>

                )}

              </div>

              <div style={styles.buttons}>

                {!todosVisiblesSeleccionados ? (

                  <button
                    type="button"
                    onClick={
                      seleccionarTodosVisibles
                    }
                    style={
                      styles.secondaryButton
                    }
                  >
                    ✓ Seleccionar visibles
                  </button>

                ) : (

                  <button
                    type="button"
                    onClick={
                      quitarTodosVisibles
                    }
                    style={
                      styles.secondaryButton
                    }
                  >
                    Quitar visibles
                  </button>

                )}

                {cadetesSeleccionados.length >
                  0 && (

                  <button
                    type="button"
                    onClick={
                      limpiarSeleccion
                    }
                    style={
                      styles.clearButton
                    }
                  >
                    Limpiar
                  </button>

                )}

              </div>

            </div>

            {/* ================================================== */}
            {/* CADETES */}
            {/* ================================================== */}

            <div style={styles.list}>

              {cadetesFiltrados.map(
                (cadete) => {

                  const dni =
                    devuelveDni(cadete);

                  const seleccionado =
                    estaSeleccionado(
                      cadete
                    );

                  return (

                    <div
                      key={dni}
                      onClick={() =>
                        toggleCadete(
                          cadete
                        )
                      }
                      style={{
                        ...styles.row,

                        ...(seleccionado
                          ? styles.rowSelected
                          : {}),
                      }}
                    >

                      {/* CHECK */}

                      <input
                        type="checkbox"
                        checked={
                          seleccionado
                        }
                        onChange={() =>
                          toggleCadete(
                            cadete
                          )
                        }
                        onClick={(e) =>
                          e.stopPropagation()
                        }
                        style={
                          styles.checkbox
                        }
                      />

                      {/* DATOS */}

                      <div style={styles.person}>

                        <div style={styles.name}>

                          {devuelveApellido(
                            cadete
                          )}{" "}
                          {devuelveNombre(
                            cadete
                          )}

                        </div>

                        <div style={styles.info}>

                          DNI {dni}

                          {devuelveSeccion(
                            cadete
                          ) &&
                            ` · ${devuelveSeccion(
                              cadete
                            )}`}

                        </div>

                      </div>

                      {/* COMPAÑÍA */}

                      <div style={styles.company}>

                        {devuelveCompania(
                          cadete
                        )}

                      </div>

                      {/* HORA */}

                      <div style={styles.time}>

                        Presente{" "}

                        <strong>
                          {formatearHoraPresente(
                            devuelveFechaPresente(
                              cadete
                            )
                          )}
                        </strong>

                      </div>

                    </div>

                  );
                }
              )}

            </div>

            {/* ================================================== */}
            {/* SELECCIONADOS */}
            {/* ================================================== */}

            {cadetesSeleccionados.length >
              0 && (

              <div style={styles.selectedFooter}>

                <strong>
                  {
                    cadetesSeleccionados.length
                  }
                </strong>{" "}
                cadete
                {
                  cadetesSeleccionados.length !==
                  1
                    ? "s"
                    : ""
                }{" "}
                seleccionado
                {
                  cadetesSeleccionados.length !==
                  1
                    ? "s"
                    : ""
                }

              </div>

            )}

          </>

        )}

      {/* ====================================================== */}
      {/* SIN PRESENTES */}
      {/* ====================================================== */}

      {!buscando &&
        promocionId &&
        cadetes.length === 0 && (

          <div style={styles.empty}>

            <strong>
              No hay cadetes presentes.
            </strong>

            <div>
              No se encontraron cadetes
              para la sede {sede} y la
              promoción seleccionada.
            </div>

          </div>

        )}

      {/* ====================================================== */}
      {/* FECHAS */}
      {/* ====================================================== */}

      {cadetesSeleccionados.length >
        0 && (

        <div style={styles.section}>

          <h3 style={styles.sectionTitle}>
            Fechas que permanecerán internos
          </h3>

          <div style={styles.dateControls}>

            <input
              type="date"
              value={fechaNueva}
              onChange={(e) =>
                setFechaNueva(
                  e.target.value
                )
              }
              style={styles.dateInput}
            />

            <button
              type="button"
              onClick={agregarFecha}
              style={
                styles.addDateButton
              }
            >
              + Agregar fecha
            </button>

          </div>

          {fechasSeleccionadas.length >
            0 && (

            <div style={styles.dateList}>

              {fechasSeleccionadas.map(
                (fecha) => (

                  <div
                    key={fecha}
                    style={styles.dateChip}
                  >

                    📅 {fecha}

                    <button
                      type="button"
                      onClick={() =>
                        quitarFecha(
                          fecha
                        )
                      }
                      style={
                        styles.removeDate
                      }
                    >
                      ×
                    </button>

                  </div>

                )
              )}

            </div>

          )}

        </div>

      )}

      {/* ====================================================== */}
      {/* RESUMEN */}
      {/* ====================================================== */}

      {cadetesSeleccionados.length >
        0 && (

        <div style={styles.summary}>

          <div style={styles.summaryItem}>

            <strong>
              {
                cadetesSeleccionados.length
              }
            </strong>

            <span>
              Cadetes
            </span>

          </div>

          <div style={styles.summaryOperator}>
            ×
          </div>

          <div style={styles.summaryItem}>

            <strong>
              {
                fechasSeleccionadas.length
              }
            </strong>

            <span>
              Fechas
            </span>

          </div>

          <div style={styles.summaryOperator}>
            =
          </div>

          <div style={styles.summaryItem}>

            <strong>
              {totalAvisos}
            </strong>

            <span>
              Avisos
            </span>

          </div>

        </div>

      )}

      {/* ====================================================== */}
      {/* CREAR */}
      {/* ====================================================== */}

      {cadetesSeleccionados.length >
        0 && (

        <button
          type="button"
          onClick={enviarAvisos}
          disabled={
            enviando ||
            fechasSeleccionadas.length ===
              0
          }
          style={{
            ...styles.submit,

            opacity:
              enviando ||
              fechasSeleccionadas.length ===
                0
                ? 0.5
                : 1,

            cursor:
              enviando ||
              fechasSeleccionadas.length ===
                0
                ? "not-allowed"
                : "pointer",
          }}
        >

          {enviando
            ? "Procesando internos..."
            : totalAvisos === 0
            ? "Seleccione las fechas"
            : `Crear ${totalAvisos} aviso${
                totalAvisos !== 1
                  ? "s"
                  : ""
              } de interno`}

        </button>

      )}

    </div>
  );
};

export default CreaAvisosInternosMasivos;

// ============================================================
// ESTILOS
// ============================================================

const styles = {

  container: {
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    boxSizing: "border-box",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: "18px",
  },

  title: {
    margin: 0,
    fontSize: "22px",
  },

  subtitle: {
    margin: "5px 0 0 0",
    color: "#777",
    fontSize: "14px",
  },

  sedeBadge: {
    padding: "8px 14px",
    background: "#edf0f2",
    borderRadius: "20px",
    fontWeight: "bold",
    fontSize: "13px",
  },

  section: {
    padding: "16px",
    border: "1px solid #e1e4e8",
    borderRadius: "10px",
    background: "#fafafa",
    marginBottom: "15px",
  },

  sectionTitle: {
    margin: "0 0 12px 0",
    fontSize: "17px",
  },

  label: {
    display: "block",
    fontWeight: "bold",
    marginBottom: "7px",
  },

  select: {
    width: "100%",
    padding: "12px",
    borderRadius: "7px",
    border: "1px solid #ccc",
    fontSize: "15px",
    background: "#fff",
  },

  loading: {
    padding: "30px",
    textAlign: "center",
    background: "#f5f5f5",
    borderRadius: "8px",
  },

  stats: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "15px",
  },

  stat: {
    minWidth: "110px",
    textAlign: "center",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    background: "#fff",
  },

  statNumber: {
    display: "block",
    fontSize: "22px",
  },

  statLabel: {
    fontSize: "12px",
    color: "#777",
  },

  filters: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "10px",
  },

  search: {
    flex: "2",
    minWidth: "240px",
    padding: "11px",
    border: "1px solid #ccc",
    borderRadius: "7px",
    fontSize: "14px",
  },

  companiaSelect: {
    flex: "1",
    minWidth: "220px",
    padding: "11px",
    border: "1px solid #ccc",
    borderRadius: "7px",
    background: "#fff",
  },

  listHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
    padding: "10px 12px",
    background: "#f3f4f5",
    border: "1px solid #ddd",
    borderRadius: "8px 8px 0 0",
  },

  filteredText: {
    fontSize: "12px",
    color: "#777",
  },

  buttons: {
    display: "flex",
    gap: "7px",
    flexWrap: "wrap",
  },

  secondaryButton: {
    padding: "8px 11px",
    background: "#fff",
    border: "1px solid #bbb",
    borderRadius: "6px",
    cursor: "pointer",
  },

  clearButton: {
    padding: "8px 11px",
    border: "1px solid #bbb",
    background: "#f1f1f1",
    borderRadius: "6px",
    cursor: "pointer",
  },

  list: {
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    maxHeight: "480px",
    overflowY: "auto",
  },

  row: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "11px 12px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
  },

  rowSelected: {
    background: "#edf7ef",
  },

  checkbox: {
    width: "19px",
    height: "19px",
    cursor: "pointer",
    flexShrink: 0,
  },

  person: {
    flex: "2",
    minWidth: "200px",
  },

  name: {
    fontWeight: "bold",
    fontSize: "14px",
  },

  info: {
    marginTop: "3px",
    fontSize: "12px",
    color: "#777",
  },

  company: {
    flex: "1",
    minWidth: "160px",
    fontSize: "12px",
    color: "#555",
  },

  time: {
    minWidth: "100px",
    fontSize: "12px",
    color: "#555",
    textAlign: "right",
  },

  selectedFooter: {
    padding: "10px",
    textAlign: "right",
    background: "#f3f4f5",
    border: "1px solid #ddd",
    borderRadius: "0 0 8px 8px",
  },

  empty: {
    padding: "30px",
    textAlign: "center",
    background: "#f5f5f5",
    borderRadius: "8px",
    color: "#666",
  },

  dateControls: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },

  dateInput: {
    flex: "1",
    minWidth: "220px",
    padding: "11px",
    border: "1px solid #ccc",
    borderRadius: "7px",
  },

  addDateButton: {
    padding: "11px 16px",
    border: "none",
    borderRadius: "7px",
    background: "#252a30",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold",
  },

  dateList: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginTop: "12px",
  },

  dateChip: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    padding: "7px 10px",
    background: "#e9ecef",
    borderRadius: "18px",
  },

  removeDate: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "18px",
  },

  summary: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    padding: "17px",
    background: "#f5f6f7",
    borderRadius: "10px",
    marginBottom: "12px",
  },

  summaryItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  summaryOperator: {
    fontSize: "20px",
    color: "#777",
  },

  submit: {
    width: "100%",
    padding: "15px",
    border: "none",
    borderRadius: "8px",
    background: "#20252b",
    color: "white",
    fontWeight: "bold",
    fontSize: "16px",
  },
};